import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteApiKey } from '../../../../common/api/clients/apiKey.api';
import { queries } from '../../../../common/api/queryKeys/queries';

export const useApiKeyDelete = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteApiKey,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queries.apiKeys.list._def });
        },
    });
};
